import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

// REACT_APP_FIREBASE_CONFIG (JSON of a Firebase web app config) switches the
// project, e.g. to run the panel locally against the dev backend, whose users
// live in the dev Firebase project (docs/DEV_ENVIRONMENT.md). Unset = production.
const firebaseConfig = process.env.REACT_APP_FIREBASE_CONFIG ? JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG) : {
  apiKey: "AIzaSyBIkrzYn9zV-8LdcSKlAGpCeZKFqDuAoio",
  authDomain: "natchnienie-studio-48cbe.firebaseapp.com",
  projectId: "natchnienie-studio-48cbe",
  storageBucket: "natchnienie-studio-48cbe.firebasestorage.app",
  messagingSenderId: "123496882507",
  appId: "1:123496882507:web:b8f10f8481693049bb08ce",
  measurementId: "G-4RXHDVPXMS"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Set persistence to LOCAL so auth state persists across browser sessions and navigation
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});
